import actionTypes from '../constants/action-types';
import globals from '../../globals';
import DEFAULT_OPTIONS from '../constants/default-options';

const insertElement = (element, refElementId, position = 'afterend', options = DEFAULT_OPTIONS) =>
  globals.helpers.globalActionExtender({
    type: actionTypes.INSERT_ELEMENT,
    payload: {
      element,
      refElementId,
      position,
      options,
    },
  });

export default insertElement;
